<script lang="ts" context="module">
  export interface Iframe {
    contentWindow: {
      postMessage: (
        arg0: {
          mid: any;
          url: any;
          availableApps: any;
          environment: any;
          merchantInfo: any;
          cartObject: any;
          token: string;
          discountCode: string;
          _fbp: string;
          _fbc: string;
          note_attributes: any;
          isAbandonCart: boolean;
          sourceValue: any;
          requestId: RequestIdData;
          cartError: boolean;
          type: string;
          cashToPrepaidRequestId;
          abcRequestId: string;
          abandonCartObject: AbandonCartInterface;
          sessionId: string;
          channelSource: string;
          channel: string;
          cashToPrepaidFlag: boolean;
          isSkipOtp: boolean;
          soToken: soTokenInterface;
          isHydrogen: boolean;
          kwikKey: string;
          sourceUrl: string;
          shopifySessionId: string;
          kpPhoneNumber: string;
          kpEmail: string;
          jwtTokensArray: string[];
          snapchatAttributes: any;
          shopify_landing_page: string;
          shopify_orig_referrer: string;
          localStorageObject: LocalStorageInterface;
          isSameWindowRedirection: boolean;
          isSuccess: boolean;
          gokwikOid: string;
          isGlanceEnvironment: boolean;
          gaCookies: string;
          parentWidth: number;
          sa_shopify_y?: string;
          sa_shopify_t?: string;
          sa_shopify_p?: string;
          sa_localization?: string;
          sp_duid?: string;
          fbExternalId?: string;
          kpFbCliId?: string;
          kwikpass_user_token?: string;
        },
        arg1: string | boolean
      ) => void;
    };
  }
</script>

<script lang="ts">
  import * as css from './styles';
  import { onMount } from 'svelte';
  import type {
    AbandonCartInterface,
    AvailableApps,
    LocalStorageInterface,
    MerchantInfoInterface,
    RequestIdData,
    soTokenInterface,
  } from '../common/services/Interfaces';
  import { getPath, xhrPostCall } from './services/Helper.service';
  import { analytics_api } from 'common/services/EnvironmentService';

  let checkoutIframe: Iframe;
  export let cartObject: any,
    mid: string,
    url: string,
    availableApps: AvailableApps,
    merchantInfo: MerchantInfoInterface,
    environment: string,
    token: string,
    discountCode: string,
    note_attributes: any,
    _fbp: string,
    _fbc: string,
    cashToPrepaidFlag: boolean,
    cashToPrepaidRequestId: any,
    sourceValue: any,
    requestId: RequestIdData,
    isAbandonCart: boolean,
    cartError: boolean,
    abcRequestId: string,
    sessionId: string,
    channelSource: string,
    channel: string,
    abandonCartObject: AbandonCartInterface,
    isSkipOtp: boolean,
    soToken: soTokenInterface,
    kwikKey: string,
    isHydrogen: boolean,
    sourceUrl: string,
    shopifySessionId: string,
    kpPhoneNumber: string,
    kpEmail: string,
    jwtTokensArray: string[],
    snapchatAttributes: any,
    shopify_landing_page: string,
    shopify_orig_referrer: string,
    localStorageObject: LocalStorageInterface,
    isSameWindowRedirection: boolean,
    isSuccess: boolean,
    gokwikOid: string,
    isGlanceEnvironment: boolean,
    sa_shopify_y: string,
    sa_shopify_t: string,
    sa_shopify_p: string,
    sa_localization: string,
    sp_duid: string,
    gaCookies,
    fbExternalId: string,
    kpFbCliId: string,
    kwikpass_user_token: string;
  onMount(() => {
    try {
      window.addEventListener('message', (ev) => {
        if (ev.data === 'clearGokwikIframeInterval') {
          clearInterval(iframeInterval);
        }
      });
      let iframeInterval = setInterval(() => {
        checkoutIframe.contentWindow.postMessage(
          {
            mid,
            cartObject,
            url,
            availableApps,
            environment,
            merchantInfo,
            token,
            discountCode,
            _fbc,
            cashToPrepaidFlag,
            cashToPrepaidRequestId,
            _fbp,
            channelSource,
            channel,
            note_attributes,
            isAbandonCart,
            requestId,
            sourceValue,
            cartError,
            abcRequestId,
            abandonCartObject,
            sessionId,
            isSkipOtp,
            soToken,
            kwikKey,
            isHydrogen,
            type: 'launch',
            sourceUrl,
            shopifySessionId,
            kpPhoneNumber,
            kpEmail,
            jwtTokensArray,
            snapchatAttributes,
            shopify_landing_page,
            shopify_orig_referrer,
            localStorageObject,
            isSameWindowRedirection,
            isSuccess,
            gokwikOid,
            isGlanceEnvironment,
            sa_shopify_y,
            sa_shopify_t,
            sa_shopify_p,
            sa_localization,
            sp_duid,
            gaCookies,
            parentWidth: window.screen.availWidth,
            kpFbCliId,
            kwikpass_user_token,
            fbExternalId,
          },
          getPath(environment)
        );
      }, 200);
    } catch (error) {
      let eventBody = {
        shopifySessionId,
        merchantId: merchantInfo?.mid,
        name: 'gk_post_message_failed',
        eventType: 'development',
        type: 'event',
        _fbc,
        _fbp,
        landing_page: shopify_landing_page,
        orig_referrer: shopify_orig_referrer,
        timestamp: Date.now(),
        sa_shopify_y,
        sa_shopify_t,
        sa_shopify_p,
        domain_userid: sp_duid,
        sa_localization,
        userAgent: navigator.userAgent,
        abc_flag: isAbandonCart,
        requestId: sessionId,
        sessionId,
      };
      sourceValue && (eventBody['source'] = sourceValue);
      triggerEventCall(eventBody);
    }
  });

  function getNewUiPath(env) {
    let path = getPath(env);
    if (path) {
      path = path + '/new-ui';
    }
    return path;
  }

  function triggerEventCall(obj) {
    xhrPostCall(analytics_api(environment), {}, obj);
  }
</script>

<iframe
  allowpaymentrequest
  src={`${merchantInfo.showNewUI ? getNewUiPath(environment) : getPath(environment)}/index.html`}
  title="Checkout window"
  bind:this={checkoutIframe}
  class={!cashToPrepaidFlag ? 'gokwik-iframe' : 'gokwik-codIframe'}
  id="gokwik-iframe"
  allow="otp-credentials; web-share; clipboard-write"
/>
